<template>
    <div class="modal show">
        <div
            class="modal-backdrop show"
            :style="{ zIndex: 'unset' }"
            @click.self="$emit('close')"
        ></div>
        <section :style="{ zIndex: 1 }">
            <div class="modal-dialog popup selectTaskModal">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title">
                            {{ trans('Select a task') }}
                        </div>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="$emit('close')"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <form class="row" @submit.prevent="search">
                            <div class="col-12 my-3">
                                <div class="form-inline">
                                    <div class="form-group w-100">
                                        <input
                                            style="width: 91%"
                                            v-model="filter.search"
                                            @keyup.enter="searchTask"
                                            :placeholder="trans('Search')"
                                            class="form-control input-md"
                                            ref="search"
                                        />
                                        <button
                                            type="button"
                                            class="btn btn-primary btn-sm ml-2"
                                            @click="searchTask()"
                                        >
                                            <i class="icofont-ui-search"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="task-list">
                                    <template v-if="isSearching">
                                        <div class="text-center mb-2">
                                            <i class="icofont-spinner"></i>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <template v-if="tasks.data.length > 0">
                                            <div
                                                class="card p-2 my-1 cur-pointer"
                                                v-for="task in tasks.data"
                                                @click="selectTask(task.task.id)"
                                            >
                                                <div
                                                    class="d-flex align-items-center"
                                                    v-if="task.task.title !== null"
                                                >
                                                    <span>
                                                        <b>
                                                            <i class="icofont-tasks-alt"></i>
                                                        </b>
                                                        {{ task.task.title }}
                                                    </span>
                                                </div>

                                                <div class="d-flex align-items-center">
                                                    <span
                                                        class
                                                        v-if="
                                                            task.task.relatable &&
                                                            task.task.relatable_type === 'project'
                                                        "
                                                    >
                                                        <b>
                                                            <i
                                                                class="icofont-chart-flow-2 mr-1"
                                                            ></i>
                                                        </b>
                                                        {{ task.task.project.title }}
                                                    </span>
                                                    <span
                                                        class
                                                        v-if="
                                                            task.task.relatable &&
                                                            task.task.relatable_type ===
                                                                'project' &&
                                                            task.task.project != null &&
                                                            task.task.project.internal_id !== null
                                                        "
                                                    >
                                                        &nbsp;
                                                        <b>-</b>
                                                        &nbsp;
                                                        {{ task.task.project.internal_id }}
                                                    </span>
                                                </div>
                                                <div
                                                    class="d-flex align-items-center"
                                                    v-if="task.task.clientable !== null"
                                                >
                                                    <span class v-if="task.client_name != null">
                                                        <b>
                                                            <span
                                                                v-if="task.client_type == 'company'"
                                                            >
                                                                <i
                                                                    class="icofont-building-alt mr-1"
                                                                ></i>
                                                            </span>
                                                            <span v-else>
                                                                <i
                                                                    class="icofont-user-alt-3 mr-1"
                                                                ></i>
                                                            </span>
                                                        </b>
                                                        {{ task.client_name }}
                                                    </span>
                                                </div>
                                                <div>
                                                    <span
                                                        class="d-flex align-items-center"
                                                        v-if="task.task.location_to_show != null"
                                                    >
                                                        <i class="icofont-location-pin"></i>
                                                        <div class="d-flex flex-column ml-2">
                                                            <span>
                                                                {{
                                                                    task.task.location_to_show
                                                                        .street +
                                                                    ' ' +
                                                                    task.task.location_to_show
                                                                        .number
                                                                }}
                                                                <span
                                                                    v-if="
                                                                        task.task.location_to_show
                                                                            .bus
                                                                    "
                                                                >
                                                                    {{
                                                                        task.task.location_to_show
                                                                            .bus
                                                                    }}
                                                                </span>
                                                                <span>
                                                                    -&nbsp;
                                                                    {{
                                                                        task.task.location_to_show
                                                                            .zip +
                                                                        ' ' +
                                                                        task.task.location_to_show
                                                                            .city
                                                                    }}
                                                                </span>
                                                            </span>

                                                            <span>
                                                                {{
                                                                    task.task.location_to_show
                                                                        .country
                                                                }}
                                                            </span>
                                                        </div>
                                                    </span>
                                                </div>
                                                <div
                                                    class="d-flex align-items-center"
                                                    v-if="task.task.status !== null"
                                                >
                                                    <span>
                                                        <span
                                                            class="badge-round round-sm"
                                                            :style="{
                                                                backgroundColor:
                                                                    task.task.status.color,
                                                            }"
                                                        ></span>

                                                        <span
                                                            :class="{
                                                                'font-italic':
                                                                    task.task.status.deleted_at,
                                                            }"
                                                            >{{ task.task.status.title }}</span
                                                        >
                                                    </span>
                                                </div>
                                            </div>
                                            <template v-if="loading">
                                                <div class="text-center mb-2">
                                                    <i class="icofont-spinner"></i>
                                                </div>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <h5 class="text-center my-3">
                                                <template v-if="initialState">{{
                                                    trans('Enter your search')
                                                }}</template>
                                                <template v-else>{{
                                                    trans('No results for this search')
                                                }}</template>
                                            </h5>
                                        </template>
                                    </template>
                                </div>
                            </div>
                        </form>
                    </div>
                    <!--/ modal-body -->
                </div>
                <!--/ modal-content -->
            </div>
        </section>
    </div>
</template>
<script>
export default {
    data() {
        return {
            tasks: {
                current_page: 1,
                last_page: 1,
                data: [],
            },
            filter: {
                search: '',
            },
            isRequesting: false,
            initialState: true, //used to manage state if search is used first time after component mounted
            loading: false,
            isSearching: false,
            client_name: null,
            client_type: null,
        };
    },
    methods: {
        // search tasks
        search() {
            this.loading = true;
            let url = `${route('project.task.index')}?page=${this.tasks.current_page}`;

            url += `&search=${this.filter.search}`;

            axios
                .get(url)
                .then((response) => {
                    let respData = response.data;

                    respData.tasks.data = respData.tasks.data.map((item) => {
                        let client = this.getClientInfoFromTask(item);
                        item = {
                            client_name: client.name,
                            client_type: client.type,
                            task: item,
                        };
                        return item;
                    });

                    if (respData.tasks.current_page > 1) {
                        this.tasks.data = this.tasks.data.concat(respData.tasks.data);
                    } else {
                        this.tasks.data = respData.tasks.data;
                    }

                    this.tasks.current_page = respData.tasks.current_page;
                    this.tasks.last_page = respData.tasks.last_page;
                    this.isRequesting = false;
                    this.initialState = false;
                    this.isSearching = false;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                    this.isSearching = false;
                });
        },
        getClientInfoFromTask(task) {
            let client = {
                name: null,
                type: null,
                id: 0,
            };
            if (task.relatable !== null) {
                if (task.relatable_type === 'company') {
                    client.name = task.relatable.company_name;
                    client.type = 'company';
                    client.id = task.relatable.id;
                } else if (task.relatable_type === 'contact') {
                    client.name = task.relatable.first_name + ' ' + task.relatable.last_name;
                    client.type = 'contact';
                    client.id = task.relatable.id;
                } else if (task.relatable_type === 'project') {
                    if (task.project.clientable) {
                        if (task.project.clientable_type === 'company') {
                            client.name = task.project.clientable.company_name;
                            client.type = 'company';
                            client.id = task.project.clientable.id;
                        } else if (task.project.clientable_type === 'contact') {
                            client.name =
                                task.project.clientable.first_name +
                                ' ' +
                                task.project.clientable.last_name;
                            client.type = 'contact';
                            client.id = task.project.clientable.id;
                        }
                    }
                }
            }
            return client;
        },
        selectTask(taskId) {
            this.$emit('taskSelected', taskId);
        },
        searchTask() {
            //only search if search input field has some value
            if (this.filter.search !== '') {
                this.tasks.current_page = 1;
                this.isSearching = true;
                this.search();
            }
        },
        taskListScroller() {
            // Detect when scrolled to bottom.
            const listElm = document.querySelector('.task-list');
            listElm.addEventListener('scroll', (e) => {
                if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
                    if (this.tasks.current_page < this.tasks.last_page) {
                        this.tasks.current_page += 1;
                        this.search();
                    }
                }
            });
        },
    },
    mounted() {
        this.taskListScroller();
        this.$refs.search.focus();
        // this.$nextTick(() => this.$refs.search.focus());
    },
};
</script>
